import { render, staticRenderFns } from "./AssociatedProductLinks.vue?vue&type=template&id=4054f74a"
import script from "./AssociatedProductLinks.vue?vue&type=script&lang=js"
export * from "./AssociatedProductLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports